<template>
    <div v-if="eventState" class="d-flex justify-content-center" :title="eventDetails">
        <div :class="['state-icon', eventState]">
            <i :class="['fa', eventStateIcon]"></i>
        </div>
    </div>
</template>

<script>
import Utils from "@/services/utils.js";

export default {
  name: "EventStateRenderer",
  props: ["object"],
  computed: {
      eventState: function () {
        if (this.object["event_state"] === null) return null;
        
        if (this.object["event_state"]) {
            if (
                this.object["event_state_meta"] && 
                Object.keys(this.object["event_state_meta"]).filter(element => {
                    // If SFR, remove SMS permission display
                    return !(Utils.getThemeName() === 'sfr' && element === "sms")
                }).every(key => this.object["event_state_meta"][key])
            ) {
                return 'success';
            }
            return 'warning';
        }
        return 'danger';
      },
      eventStateIcon: function () {
        const iconMap = {
            "success": "fa-check",
            "warning": "fa-warning",
            "danger": "fa-times",
        };

        return this.eventState ? iconMap[this.eventState] : null;
      },
      eventDetails: function () {
        if (!this.object["event_state_meta"]) return null;

        const details = Object.keys(this.object["event_state_meta"])
            .filter(element => {
                // If SFR, remove SMS permission display
                return !(Utils.getThemeName() === 'sfr' && element === "sms")
            })
            .map(element => {
                const label = window.V.$i18n.t(`reports.logsTable.events.details.${element}`);
                return this.object["event_state_meta"][element] ? `✓ ${label}` : `✖ ${label}`;
            });

        return details.join(', ')
      }
  }
};
</script>

<style lang="scss" scoped>
.state-icon {
    border-radius: 50%;
    height: 20px;
    width: 20px;
    min-width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10px;

    &.success {
        background-color: var(--colors-success-400);
    }

    &.warning {
        background-color: var(--colors-warning-400);
    }

    &.danger {
        background-color: var(--colors-danger-400);
    }

    &:hover {
        cursor: help;
    }
}
</style>
  